<template>
  <div class="declareWraper">
    <div class="title">{{ formItem.title }}</div>
    <div class="desc">
      <p v-for="(p, idx) in contents" :key="idx" v-html="p"></p>
    </div>
    <div class="declares">
      <div v-for="l in list" class="item">
        <p @click="go(l)" class="link">{{ l.title }}</p>
        <p class="tip">{{ l.desc }}</p>
        <p class="btn">
          <span @click="agree(l)" :class="[{ agreed: l.value == 1 }, `${country}-btn-span`]">
            <i v-show="l.value == 1"></i>
            {{ l.main_button_title || l.button[l.value] }}
          </span>
        </p>
      </div>
    </div>
    <div
      class="bottom"
      v-if="(formItem.submit_btn ? formItem.field_status != 3 : true) && formItem.field_status != 4 && formItem.hide_complete_btn != 1"
    >
      <p v-if="formItem.submit_btn" @click="submit" :class="['submit-btn', `${country}-submit-btn`]">{{submit_btn.title}}</p>
      <p v-else :class="[{ done: all_agreed }, { [`${country}-done`]: all_agreed }]" @click="back">
        {{ done_tip + $t("complete") }}
      </p>
    </div>
    <load-link :src="tmpLink" :show="showLink" @close="closeLink"></load-link>
  </div>
</template>
<script>
import loadLink from "./load-link";
import { post } from "../../tools/request";
import { showLoadingToast, showAlertDialog, showToast } from "../../tools/Tip";
import { mapState } from "vuex";
export default {
  data() {
    return { tmpLink: "", showLink: false, bakConfig: {} };
  },
  computed: {
    ...mapState(["_ticket"]),
    //传递过来整个对象
    formItem() {
      let c = this.$route.params.configs;
      return c || this.bakConfig;
    },
    contents() {
      return this.formItem.content || [];
    },
    list() {
      return this.formItem.list || [];
    },
    submit_btn() {
      return this.formItem.submit_btn || {}
    },
    done_tip() {
      return (
        this.list.filter(x => x.value == 1).length +
        "/" +
        this.list.length +
        " "
      );
    },
    all_agreed() {
      return this.list.every(item => {
        return item.value == 1;
      });
    },
    country() {
      let up = new URLSearchParams(location.search)
      return up.get('location_country')
    },
  },
  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  components: { loadLink },
  methods: {
    go(item) {
      //@20200313 支持跳转第三方链接
      if (item.third_link == 1) {
        location.href = item.title_link;
        return;
      }
      this.tmpLink = item.title_link;
      this.showLink = true;
    },
    closeLink() {
      this.showLink = false;
    },
    agreeReq(type, option, cb) {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      if (type === 'declares') {
        up.set(option.key, 1);
      } else if (type === 'submit') {
        if (option.value_type === 'timestamp') {
          let timeStamp = Math.floor(new Date().getTime() / 1000)
          up.set(option.key, timeStamp)
        }

      }

      post(process.env.ADD_AUDI_INFO, up)
        .then(data => {
          this.toast.hide();
          typeof cb === 'function' && cb();
        })
        .catch(res => {
          this.toast.hide();
          showAlertDialog(this, res.errmsg);
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: process.env.ADD_AUDI_INFO,  //接口url
              message: JSON.stringify(res),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: res.errno,  //报错码
            });
          } catch (e) {}
        });
    },
    agree(item) {
      if (item.third_link == 1) {
        location.href = item.title_link;
        return;
      }
      if (item.value == 1) {
        return;
      }
      this.agreeReq('declares', item, () => {
        item.value = 1;
        showToast(this, {
          type: "correct",
          txt: item.success_tip,
          time: 2000
        });
      });

    },
    submit() {
      this.agreeReq('submit', this.submit_btn, this.back);
    },
    back() {
      this.$router.replace({ name: "home" });
    },
    reloadConfig() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      post(process.env.PHOTOINFO_URL, up)
        .then(data => {
          this.toast.hide();
          let job_type = up.get("doc_job_type");
          let result = data.form.filter(x => x.job_type === job_type);
          if (result.length) {
            this.bakConfig = result[0];
          } else {
            this.back();
          }
        })
        .catch(res => {
          this.toast.hide();
          showAlertDialog(this, res.errmsg);
        });
    }
  },
  mounted() {
    let up = new URLSearchParams(location.search);
    let route_name = up.get("doc_route_name");
    if (route_name) {
      this.reloadConfig();
    }
  }
};
</script>
<style lang="less" scoped>
.declareWraper {
  padding-bottom: 1.7rem;
}
.title {
  padding: 0.31rem;
  font-size: 0.46rem;
  font-weight: bold;
  color: #000;
}
.desc {
  padding-bottom: 0.384rem;
  p {
    padding: 0 0.65rem 0 0.19rem;
    font-size: 0.27rem;
    color: #666;
  }
}
.declares {
  font-size: 0.27rem;
  .item {
    min-height: 2.18rem;
    padding: 0 0.31rem;
    margin-bottom: 0.2rem;
    background: #fff;
  }
  .link {
    padding-top: 0.27rem;
    font-weight: bold;
    color: #ff6d1f;
  }
  .tip {
    position: relative;
    padding: 0.12rem 0 0.21rem 0;
    color: #666;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      border-bottom: 1px #d8d8d8 solid;
      width: 100%;
      transform: scaleY(0.5);
      transform-origin: 0 0;
    }
  }
  .btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 0.96rem;
    span {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2.18rem;
      height: 0.672rem;
      color: #ff6d1f;
      &::after {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        width: 200%;
        height: 200%;
        border: 1px solid #ff6d1f;
        border-radius: 0.06rem;
        transform: scale(0.5);
        transform-origin: 0 0;
      }
      // &.BR-btn-span::after {
      //   border: 1px solid #ffe600;
      // }
      i {
        width: 0.18rem;
        height: 0.1rem;
        border-left: 0.04rem #ccc solid;
        border-bottom: 0.04rem #ccc solid;
        transform: rotate(-40deg);
        transform-origin: 0.04rem 0.2rem;
      }
    }
    span.agreed {
      color: #ccc;
      &:after {
        border: 1px solid #ccc;
      }
    }
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0.31rem;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 0 0.16rem rgba(136, 136, 136, 0.5);
  p {
    height: 1.08rem;
    font-size: 0.36rem;
    line-height: 1.08rem;
    color: #fff;
    text-align: center;
    background: #cccccc;
    border-radius: 4px;
  }
  p.done {
    background: #ff7226;
    &.BR-done {
      color: #000;
      background: #ffe600;
    }
  }
  p.submit-btn {
    background: #ff7226;
    &.BR-submit-btn {
      color: #000;
      background: #ffe600;
    }
  }
}
</style>
